import { ReactComponent as CostIcon } from "../../../assets/icons/bill.svg";
import { ReactComponent as DashboardIcon } from "../../../assets/icons/dash.svg";
import { ReactComponent as InventoryIcon } from "../../../assets/icons/inventory.svg";
import { ReactComponent as ExpensesIcon } from "../../../assets/icons/moneys.svg";
import { ReactComponent as ProfileIcon } from "../../../assets/icons/profile.svg";
import { ReactComponent as DriverIcon } from "../../../assets/icons/two-user.svg";

export interface NavItem {
  id: string;
  name: string;
  permissionName: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  subItems?: SubNavItem[];
}

export interface SubNavItem {
  id: string;
  name: string;
  permissionName: string;
  icon?: React.ComponentType<any>;
}

export const navItems: NavItem[] = [
  {
    id: "",
    name: "Dashboard",
    permissionName: "Dashboard",
    icon: DashboardIcon,
  },
  {
    id: "users",
    name: "User management",
    permissionName: "Users",
    icon: ProfileIcon,
  },
  {
    id: "companies",
    name: "Companies",
    permissionName: "hangfire",
    icon: DriverIcon,
  },
  {
    id: "subscription",
    name: "Subscription",
    permissionName: "hangfire",
    icon: ExpensesIcon,
    subItems: [
      {
        id: "subscription",
        name: "subscription",
        permissionName: "hangfire",
      },
      {
        id: "custom-pricing",
        name: "All plans",
        permissionName: "hangfire",
      },
    ],
  },
  {
    id: "transaction",
    name: "Transaction",
    permissionName: "Hangfire",
    icon: CostIcon,
  },
  {
    id: "vehicle-brands",
    name: "Brands",
    permissionName: "Hangfire",
    icon: InventoryIcon,
  },
  {
    id: "audit-log",
    name: "Audit log",
    permissionName: "maintenance",
    icon: InventoryIcon,
  },
];
